!function(){"use strict";customElements.get("quantity-counter")||customElements.define("quantity-counter",class extends HTMLElement{constructor(){super()}connectedCallback(){this.input=this.querySelector("input"),this.changeEvent=new Event("change",{bubbles:!0}),this.buttonClickEvent=this.onButtonClick.bind(this),this.onQuantityChangeEvent=this.onQuantityChange.bind(this),this.input.addEventListener("change",this.onQuantityChangeEvent),this.querySelectorAll("button").forEach((t=>t.addEventListener("click",this.buttonClickEvent)))}onButtonClick(t){t.preventDefault();const e=this.input.value,n="BUTTON"==t.target.nodeName?t.target:t.target.closest("button");"increase"===n.name&&this.input.stepUp(),"decrease"===n.name&&this.input.stepDown(),e!==this.input.value&&this.input.dispatchEvent(this.changeEvent)}onQuantityChange(){"updates[]"==this.input.name&&this.updateCart()}updateCart(){""!==this.quantityValue&&this.dispatchEvent(new CustomEvent("theme:cart:update",{bubbles:!0,detail:{id:this.input.dataset.id,quantity:this.input.value}}))}})}();

(function() {
  // Register engraving cart handlers once when this asset is included multiple times.
  if (window.__rfsEngravingCartSyncInitialized) return;
  window.__rfsEngravingCartSyncInitialized = true;

  var ENGRAVING_VARIANT_IDS = ['46489784418493', '46489784451261'];
  var PAID_ENGRAVING_PRODUCT_TITLE = /\bheirloom signet\b/i;
  var ENGRAVING_PROPERTY_KEYS = {
    Engraving: true,
    '_Engraving group': true,
    '_Engraving fee required': true
  };

  var engravingSyncQueue = Promise.resolve();
  var activeFeeRemovalKeys = {};
  var allowNextCheckoutSubmit = false;

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function getProperties(item) {
    return item && item.properties && typeof item.properties === 'object' ? item.properties : {};
  }

  function getProperty(item, key) {
    var value = getProperties(item)[key];
    return value == null ? '' : String(value).trim();
  }

  function getQuantity(item) {
    var quantity = Number(item && item.quantity);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return String(value).replace(/["\\]/g, '\\$&');
  }

  function queueEngravingSync(task) {
    engravingSyncQueue = engravingSyncQueue.catch(function() {}).then(task);
    return engravingSyncQueue;
  }

  function isEngravingFeeItem(item) {
    if (!item) return false;

    var variantId = String(item.variant_id || '');
    var title = normalize(item.product_title || item.title);

    return ENGRAVING_VARIANT_IDS.indexOf(variantId) !== -1 ||
      (title === 'engraving' && getProperty(item, '_Engraving text') !== '');
  }

  function isPaidEngravingMainItem(item) {
    if (!item || isEngravingFeeItem(item) || getProperty(item, 'Engraving') === '') {
      return false;
    }

    var title = item.product_title || item.title || '';

    return getProperty(item, '_Engraving fee required') === 'true' ||
      PAID_ENGRAVING_PRODUCT_TITLE.test(title);
  }

  function getMainSignature(item) {
    var group = getProperty(item, '_Engraving group');

    if (group !== '') {
      return 'group:' + group;
    }

    return 'text:' + normalize(getProperty(item, 'Engraving')) +
      '|for:' + normalize(item.product_title || item.title);
  }

  function getFeeSignature(item) {
    var group = getProperty(item, '_Engraving group');

    if (group !== '') {
      return 'group:' + group;
    }

    return 'text:' + normalize(getProperty(item, '_Engraving text')) +
      '|for:' + normalize(getProperty(item, '_Engraving for'));
  }

  function getOrphanedEngravingItems(cart) {
    var feeCounts = {};
    var orphanedItems = [];
    var items = cart && Array.isArray(cart.items) ? cart.items : [];

    items.filter(isEngravingFeeItem).forEach(function(item) {
      var signature = getFeeSignature(item);

      if (signature === 'text:|for:') return;

      feeCounts[signature] = (feeCounts[signature] || 0) + getQuantity(item);
    });

    items.filter(isPaidEngravingMainItem).forEach(function(item) {
      var signature = getMainSignature(item);
      var quantity = getQuantity(item);
      var availableFees = feeCounts[signature] || 0;

      if (availableFees >= quantity) {
        feeCounts[signature] = availableFees - quantity;
        return;
      }

      orphanedItems.push(item);
    });

    return orphanedItems;
  }

  function getPropertiesWithoutEngraving(item) {
    var nextProperties = {};
    var properties = getProperties(item);

    Object.keys(properties).forEach(function(key) {
      var value = properties[key];

      if (ENGRAVING_PROPERTY_KEYS[key] || value == null || value === '') {
        return;
      }

      nextProperties[key] = value;
    });

    return nextProperties;
  }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json'
      }
    }).then(function(response) {
      if (!response.ok) throw new Error('Unable to read cart.');
      return response.json();
    });
  }

  function changeCart(payload) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(function(response) {
      if (!response.ok) throw new Error('Unable to update cart.');
      return response.json();
    });
  }

  function setLineBusy(lineKey, busy) {
    if (!lineKey) return;

    document.querySelectorAll('[data-item="' + cssEscape(lineKey) + '"]').forEach(function(item) {
      item.classList.toggle('is-loading', busy);
      item.querySelectorAll('button, a, input').forEach(function(control) {
        if ('disabled' in control) {
          control.disabled = busy;
        }
      });
    });
  }

  function reloadCartView() {
    window.location.reload();
  }

  function cleanOrphanedEngravings(shouldReload) {
    return queueEngravingSync(function() {
      return fetchCart()
        .then(function(cart) {
          var orphanedItems = getOrphanedEngravingItems(cart);

          return orphanedItems.reduce(function(chain, item) {
            return chain.then(function() {
              return changeCart({
                id: item.key,
                quantity: getQuantity(item),
                properties: getPropertiesWithoutEngraving(item)
              });
            });
          }, Promise.resolve()).then(function() {
            return orphanedItems.length > 0;
          });
        });
    }).then(function(cleaned) {
      if (cleaned && shouldReload) {
        reloadCartView();
      }

      return cleaned;
    });
  }

  function removeFeeLineAndSync(lineKey) {
    if (!lineKey || activeFeeRemovalKeys[lineKey]) return;

    activeFeeRemovalKeys[lineKey] = true;
    setLineBusy(lineKey, true);

    queueEngravingSync(function() {
      return changeCart({
        id: lineKey,
        quantity: 0
      })
        .then(fetchCart)
        .then(function(cart) {
          var orphanedItems = getOrphanedEngravingItems(cart);

          return orphanedItems.reduce(function(chain, item) {
            return chain.then(function() {
              return changeCart({
                id: item.key,
                quantity: getQuantity(item),
                properties: getPropertiesWithoutEngraving(item)
              });
            });
          }, Promise.resolve());
        });
    })
      .then(function() {
        delete activeFeeRemovalKeys[lineKey];
        reloadCartView();
      })
      .catch(function() {
        delete activeFeeRemovalKeys[lineKey];
        window.location.href = '/cart/change?id=' + encodeURIComponent(lineKey) + '&quantity=0';
      });
  }

  function lineLooksLikeEngravingFee(cartLine) {
    return normalize(cartLine && cartLine.getAttribute('data-item-title')) === 'engraving';
  }

  document.addEventListener('click', function(event) {
    var removeLink = event.target.closest('[data-item-remove]');
    var minusButton = event.target.closest('.cart__quantity-minus, button[name="decrease"]');
    var cartLine = event.target.closest('[data-item]');

    if (!cartLine || (!removeLink && !minusButton) || !lineLooksLikeEngravingFee(cartLine)) {
      return;
    }

    if (minusButton) {
      var quantityField = cartLine.querySelector('[name="updates[]"]');

      if (quantityField && Number(quantityField.value) > 1) {
        return;
      }
    }

    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    removeFeeLineAndSync(cartLine.getAttribute('data-item') || (removeLink && removeLink.getAttribute('data-id')));
  }, true);

  document.addEventListener('submit', function(event) {
    var form = event.target.closest('form[action*="/cart"]');
    var submitter = event.submitter || document.activeElement;
    var isCheckout = submitter && submitter.getAttribute && submitter.getAttribute('name') === 'checkout';

    if (!form || !isCheckout || allowNextCheckoutSubmit) {
      allowNextCheckoutSubmit = false;
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    cleanOrphanedEngravings(false).finally(function() {
      allowNextCheckoutSubmit = true;

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(submitter);
      } else {
        window.location.href = '/checkout';
      }
    });
  }, true);

  document.addEventListener('DOMContentLoaded', function() {
    var isCartPage = /\/cart\/?$/.test(window.location.pathname);

    cleanOrphanedEngravings(isCartPage).catch(function() {
      // If cart cleanup fails, leave the normal cart behavior in place.
    });
  });
})();